import styled from 'styled-components';

export const ModalBody = styled.section`
  overflow-y: auto;
  border-bottom: 1px solid ${(p) => p.theme.c.border.primary};
  padding-bottom: 10px;
  ${({ theme }) => theme.typographyRebrand.body.md}

  .modal-header-text {
    text-align: left;
    ${({ theme }) => theme.typographyRebrand.heading['2xl']}
    margin-bottom: ${({ theme }) => theme.unit(3)}
  }

  strong {
    font-weight: var(--typography-font-weight-bold);
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  margin: 16px;
  background-color: transparent;
  border: none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  @media screen and (max-width: ${p => p.theme.breakpoint.mobile}px) {
    margin: 12px;
  }

  svg > path {
    fill: ${(p)=> p.theme.c.icon.interactive};
  }
`;

export const ModalWrapper = styled.div`
  position: absolute;
  top:0;
  left:0;
  right:0;
  z-index: 40;
  
  .contentStyles {
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 600px;
    height: 80%;
    background-color: ${(p) => p.theme.c.bg.primary};
    padding: 48px 24px;
    border-radius: 16px;
    ${({ theme }) => theme['elevation-shadow']['3']}
    @media screen and (max-width: ${p => p.theme.breakpoint.mobile}px) {
      padding: 2rem 1rem;
    }
  }

  .overlayStyles {
    padding: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    background-color: ${({ theme }) => theme.c.overlay.background};
    backdrop-filter: 'blur(4px)';
    justify-content: center;
    align-items: center;
  }
`;
